import { Fragment, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { Notice } from "../../lib/ui";

/* Purchase history – port of purchase_history.php (API: /api/purchasing/history). Last 30 days by default; open a batch to see its items. */

export default function PurchaseHistory() {
  const api = useApi();
  const [f, setF] = useState({ from: "", to: "" });
  const [form, setForm] = useState(f);
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(null);
  const [items, setItems] = useState({});
  const [error, setError] = useState(null);
  const load = useCallback(async (q) => { try { const r = await api.get("/api/purchasing/history", q.from ? q : {}); setD(r); setForm({ from: r.from, to: r.to }); } catch (e) { setError(e.message); } }, [api]);
  useEffect(() => { load(f); }, [load, f]);
  const toggle = (id) => {
    setOpen((o) => (o === id ? null : id));
    if (!items[id]) api.get(`/api/purchasing/history/${id}`).then((r) => setItems((x) => ({ ...x, [id]: r }))).catch((e) => setError(e.message));
  };
  return (
    <main className="pg">
      <PageHeader slug="purchase_history" actions={<Link to="/purchasing" className="btn primary"><i className="fas fa-cart-plus" /> New purchasing list</Link>} />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel" style={{ marginBottom: "1.25rem" }}>
        <form className="toolbar" style={{ borderBottom: 0 }} onSubmit={(e) => { e.preventDefault(); setF({ ...form }); }}>
          <div className="field"><label htmlFor="ph-f">From</label><input id="ph-f" type="date" value={form.from} onChange={(e) => setForm({ ...form, from: e.target.value })} /></div>
          <div className="field"><label htmlFor="ph-t">To</label><input id="ph-t" type="date" value={form.to} onChange={(e) => setForm({ ...form, to: e.target.value })} /></div>
          <button type="submit" className="btn primary">Filter</button>
          {d && <div style={{ marginLeft: "auto", textAlign: "right" }}><div style={{ fontSize: ".75rem", color: "var(--muted)" }}>Total for period</div><b className="mono" style={{ fontSize: "1.2rem" }}>TZS {n2(d.grand_total)}</b></div>}
        </form>
      </section>
      <section className="panel"><div className="tbl-wrap"><table className="tbl">
        <thead><tr><th>Batch</th><th>Completed</th><th>By</th><th className="num">Items</th><th className="num">Total</th><th>Notes</th><th /></tr></thead>
        <tbody>{d?.rows.map((b) => (
          <Fragment key={b.batch_id}>
            <tr><td className="mono" style={{ fontSize: ".78rem" }}>{b.batch_reference}</td><td>{String(b.completed_at).slice(0, 16)}</td><td>{b.completed_by_name || "–"}</td>
              <td className="num mono">{b.total_items}</td><td className="num mono">{n2(b.total_amount)}</td><td style={{ color: "var(--muted)" }}>{b.notes}</td>
              <td><button type="button" className="btn sm" aria-expanded={open === b.batch_id} onClick={() => toggle(b.batch_id)}>{open === b.batch_id ? "Hide" : "View"}</button></td></tr>
            {open === b.batch_id && (
              <tr className="po-detail"><td colSpan={7}><div className="inner">
                {!items[b.batch_id] ? <span style={{ color: "var(--muted)" }}>Loading items…</span> : (
                  <table><thead><tr><th>Product</th><th>Manufacturer</th><th className="num">Qty</th><th className="num">Price</th><th className="num">Total</th></tr></thead>
                    <tbody>{items[b.batch_id].map((it, i) => <tr key={i}><td className="c">{it.product_name}</td><td className="c">{it.manufacturer || "–"}</td>
                      <td className="c num mono">{it.quantity}</td><td className="c num mono">{n2(it.purchase_price)}</td><td className="c num mono">{n2(it.line_total)}</td></tr>)}</tbody></table>)}
              </div></td></tr>
            )}
          </Fragment>))}</tbody>
      </table>{d && d.rows.length === 0 && <div className="empty"><i className="fas fa-clock-rotate-left" />No purchase batches in this date range.</div>}</div></section>
    </main>
  );
}
